<template>
	<sf-data-table ref="variableTable" selection :paging="false" :columns="variablesCol" :rows="variables" :rowSize="'lg'"> </sf-data-table>
</template>

<script>
export default {
	props: ['PopupOpen'],

	data() {
		return {
			timer: null,
			variablesCol: [
				{
					label: 'state', //상태
					prop: 'tableState',
					minWidth: '50px',
					sortable: false
				},
				{
					label: 'varId', // 변수ID
					prop: 'varId',
					minWidth: '200px',
					sortable: true,
					form: {
						type: 'input',
						isDisabled: this.isDisabled //추가된행은 편집을 못하게 한다.
					}
				},
				{
					label: 'varValue', // 변수값
					prop: 'varValue',
					minWidth: '200px',
					sortable: true,
					form: {
						type: 'input'
					}
				},
				{
					label: 'rmk', // 비고
					prop: 'rmk',
					minWidth: '300px',
					sortable: true,
					form: {
						type: 'input'
					}
				},
				{
					label: 'useYn', // 사용여부
					prop: 'useYn',
					minWidth: '100px',
					sortable: false,
					form: {
						type: 'select',
						options: this.gridUseYnList,
						isDisabled: this.isDisabled
						// MWCC000355
					}
				},
				{
					label: 'chgId', // 수정자
					prop: 'chgId',
					minWidth: '140px',
					sortable: true
				},
				{
					label: 'chgDt', // 수정일시
					prop: 'chgDt',
					minWidth: '300px',
					sortable: true
				}
			],
			variables: [
				{
					varId: '1',
					varValue: '1',
					rmk: '1',
					chgId: '1',
					chgDt: '1',
					rgnDt: '1',
					rgnId: '1',
					tableState: 'I',
					useYn: 'Y'
				},
				{
					varId: '2',
					varValue: '2',
					rmk: '2',
					chgId: '2',
					chgDt: '2',
					rgnDt: '2',
					rgnId: '2',
					tableState: 'I',
					useYn: 'Y'
				}
			]
		};
	},
	computed: {
		selectedRow() {
			return (this.$refs.variableTable && this.$refs.variableTable.multipleSelection) || [];
		}
	},
	methods: {}
};
</script>
